angular.module('login', []);

angular.module('login')

.factory('redirectToLoginOn403', ['$q', '$location', '$rootScope', function($q, $location, $rootScope) {
  return {
    responseError: function(response) {
      if (response.status === 401 && $location.path().indexOf('/login') === -1) {
        $rootScope.$emit('onBackendError', 'Session timeout. Please login again');
        $location.path('/login');
        return $q.when({data: {data: {}}});
      }
      return $q.reject(response);
    }
  };
}])

.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push('redirectToLoginOn403');
}])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider
  .when('/login', {
    constoller: 'none',
    template: '<login-form></login-form>'
  });
}])

.component('loginForm', {
  template: require('./login.html'),
  controller: [
    '$window',
    '$location',
    function($window, $location) {
      var $ctrl = this;
      this.$onInit = function() {
        $ctrl.error = ($location.search().error) ? $location.search().error : '';
      };
      this.loginWithGoogle = function() {
        $window.location.href = '/login/google';
      };
    }
  ]
})

.component('logout', {
  template: '<a href="/logout">Logout</a>'
});



// WEBPACK FOOTER //
// ./src/login/login.js